 /*
 * @Author: jiahuacui
 * @Date: 2018-08-09 14:31:10
 * @LastEditors: jiahuacui
 * @LastEditTime: 2018-08-08 14:31:10
 * @Description:
 */
 <!--
  关联BOM
  props:
    attrValue: 默认绑定值
    customerId: 详情页id
    module 模块名
  emit:
    emitObj: 提交已选数据
 -->
 <template>
  <div class="mult-select bombill">
    <el-dialog title="选择BOM清单" :visible.sync="dialogVisible" :modal="true">
      <div class="content">
        <div class="search">
          <div class="search-left">
            <template>
              <span>产品分类：</span>
              <products-type
              @refresh="getProList">
              </products-type>
            </template>
            <el-input size="small" class="input" prefix-icon="el-icon-search" v-model="contactSearch" @change="handleSearch" placeholder="BOM、成品搜索">
            </el-input>
          </div>
        </div>
        <div class="select-list">
          <el-table
            ref="table"
            :data="userList"
            max-height="370"
            v-loading.body="loading"
            row-key="id"
            border
            @select="handleSelect"
            >
            <el-table-column
              type="selection"
              width="50"
            >
            </el-table-column>
            <el-table-column
              v-for="header in headerArray"
              :key="header.attr"
              :prop="header.attr"
              :label="header.attrName">
            </el-table-column>
          </el-table>
          <div class="pagination-wrapper">
<!--             <div v-if="multiselect" class="select-length">已选 {{idArr.length}} 个</div> -->
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-size="pageSize"
              layout="total, prev, pager, next, jumper"
              :total="total">
            </el-pagination>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary"  @click="handleSubmit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import * as api from 'src/api'
import { mapGetters } from 'vuex'
import { LS } from 'assets/js/storage'
import productsType from 'components/fieldtype/products-type.vue'
let lazy

export default {
  created () {
    this.selectContacts = JSON.parse(JSON.stringify(this.attrValue)) || []
    this.getUserList()
  },
  props: {
    attrValue: {
      type: Array,
      default: () => []
    },
    // 关联的客户ID
    customerId: {
      default: 0
    },
    // 对应的模块
    module: {
      Type: String,
      default: 'simulationProduce'
    }
    // modal: {
    //   type: Boolean,
    //   default: false
    // },
    // supplierId: {
    //   type: Number,
    //   default: 0
    // },
    // multiselect: {
    //   type: Boolean,
    //   default: false
    // },
    // fromMoudle: {
    //   type: String,
    //   default: ''
    // },
    // item: {
    //   type: Object
    // }
  },
  data () {
    return {
      contactSearch: '',
      userList: [],
      selectContacts: [],
      selectClass: false,
      // 分页信息
      currentPage: 1,
      categoryIdIn: 0, // 分类ID
      total: 0,
      dialogVisible: true,
      pageSize: 12,
      loading: false,
      group: '0',
      headerArray: [],
      dataMap: {
        [this.module]: '/bomBill/getBomBillList.html'
      },
      selectArr: [] // 多选时用来存放每一页的选项的
    }
  },
  computed: {
    ...mapGetters([
      'moduleName'
    ]),
    // 包含已选产品id的数组
    idArr () {
      return this.selectContacts.map((item) => item.id)
    },
    title () {
      if (['productionOrder', 'simulationProduce'].indexOf(this.module) > -1) {
        return 'BOM清单'
      }
    }
  },
  methods: {
    // 选中事件
    handleSelect (selection, row) {
      let selecte = []
      this.$refs.table.clearSelection()
      if (selection.length) {
        this.$refs.table.toggleRowSelection(row, true)
        selecte = [row]
      } else {
        selecte = []
      }
      console.log('selecte', selecte)
      this.selectContacts = selecte.map((item) => {
        let obj = {
          id: item.id,
          value: item.value,
          version: item.version,
          sheetNo: item.sheetNo
        }
        return obj
      })
    },
    getUserList (query) {
      this.loading = true
      let url = this.dataMap[this.module]
      let params = {
        page: this.currentPage,
        pageSize: this.pageSize,
        categoryIdIn: this.categoryIdIn,
        nameLike: query || this.contactSearch
      }
      // 生产单
      if (this.module === 'productionOrder') {
        let pageType = this.$route.query.type // 一键生产
        if (pageType === 'waitProduce') {
          let productArray = this.$route.params.productArray || LS.get('VUE-productArray')
          productArray.map((item) => {
            params.productId = item.productId
          })
        }
      }

      api.post(url, params, (data) => {
        this.loading = false
        this.userList = data.result
        this.total = data.pageHelper.rowsCount || 0
        this.dialogVisible = true
        this.currentPage = data.pageHelper.currentPageNum || 1
        this.pageSize = data.pageHelper.pageSize || 12
        this.headerArray = data.headerArray
        // checkbox初始化
        this.$nextTick(() => {
          if (this.multiselect) {
            this.selectArr[this.currentPage] = []
          }
          this.userList.forEach((item) => {
            const index = this.idArr.indexOf(item.id)
            if (index > -1) {
              this.$refs.table.toggleRowSelection(item, true)
              if (this.multiselect) {
                this.selectArr[this.currentPage].push(this.selectContacts[index])
                this.selectArr[0] = this.selectArr[0].filter(obj => {
                  if (obj.id !== item.id) {
                    return obj
                  }
                })
              }
            }
          })
        })
      })
    },
    // 获得分类组件传来的分类ID
    getProList (value, id) {
      this.categoryIdIn = id
      // 请求产品列表
      this.getUserList()
    },
    // 远程搜索
    handleSearch (query) {
      this.currentPage = 1
      query = query.toString().trim()
      window.clearTimeout(lazy)
      lazy = window.setTimeout(() => { this.getUserList(query) }, 500)
    },
    // 每页所显示的条数变更
    handleSizeChange (val) {
      this.pageSize = val
      this.getUserList()
    },
    // 当前分页变更
    handleCurrentChange (val) {
      this.currentPage = val
      this.getUserList()
    },
    // 提交已选数据
    handleSubmit () {
      this.$emit('emitObj', this.selectContacts, this.module)
      this.dialogVisible = false
    }
  },
  components: {
    productsType
  },
  watch: {
    dialogVisible () {
      if (this.dialogVisible === false) {
        this.$emit('close')
      }
    }
  }
}
</script>

<style lang="less">
.bombill {
  .el-dialog {
    position: fix1ed;
  }
  // 上面不知道为什么要fixed定位，zpp
  .el-dialog--small {
    width: 680px !important;
    background: rgb(72, 87, 106);
  }
  .el-table {
    .el-table__body tr.current-row > td {
      background: #9bbaca;
    }
  }
  .el-dialog__header,
  .el-dialog__footer {
    line-height: 1;
  }
  .el-dialog__body {
    padding: 0;
    padding-left: 10px !important;
    background: #fff;
  }
  .content {
    width: 99%;
    .search {
      padding: 9px;
      .search-left {
        .manager {
          margin: 0;
          margin-right: 20px;
          width: 180px;
          display: inline-block;
          vertical-align: top;
          .el-input {
            .el-input__inner {
              border-width: 0;
              font-size: 15px;
              font-weight: bold;
              font-family: "microsoft Yahei";
            }
          }
        }
        .input {
          width: 160px;
          margin-left: 10px;
          .el-input__inner {
            border: 1px solid rgb(191, 203, 217);
          }
        }
      }
    }
    .select-list {
      flex: 1;
      .el-table__header {
        .el-checkbox {
          display: none;
        }
      }
    }
    .pagination-wrapper {
      overflow: auto;
      display: flex;
      justify-content: space-between;
      padding: 8px 0;
    }
  }
  .dialog-footer {
    position: relative;
    .select {
      position: absolute;
      left: 200px;
      top: 4px;
      padding: 6px 15px;
      border-radius: 13px;
    }
  }
}
</style>
<style lang="less" scoped>
.bombill {
  .search,
  .search-left {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .select-length {
    line-height: 31px;
    margin-left: 10px;
    letter-spacing: 2px;
  }
}
</style>


// WEBPACK FOOTER //
// bom-bill.vue?4cc8e2b3